import { IDealership } from "@rumble-it/common-lib/src/types/Dealership";
import { Card } from "antd";
import { Button } from "./Button";

export const DealershipCard = ({
  dealership,
  isSelected,
  onClick,
}: {
  dealership: IDealership;
  isSelected: boolean;
  onClick: (dealership: IDealership) => void;
}) => {
  const addressString =
    dealership.address && dealership.address.street
      ? `${dealership.address.street} ${dealership.address.streetNumber}${dealership.address.streetNumberAddition || ""}, ${dealership.address.postalCode} ${dealership.address.city}`
      : null;

  return (
    <Card className="mb-4">
      {dealership.headerImage ? (
        <div
          className="bg-no-repeat bg-center bg-cover h-32 mb-4 rounded-lg"
          style={{
            backgroundImage: `url(${dealership.headerImage.contentUrl})`,
            backgroundSize: "cover",
          }}
        />
      ) : null}

      <h3 className="text-lg font-bold mb-2">
        {dealership.fullName || dealership.name}
      </h3>

      {addressString ? (
        <p className="text-sm text-gray-600 mb-2">{addressString}</p>
      ) : null}

      {dealership.sphericalDistanceInMeter &&
      dealership.sphericalDistanceInMeter !== undefined &&
      dealership.sphericalDistanceInMeter !== null &&
      dealership.sphericalDistanceInMeter > 0 ? (
        <p className="text-sm text-gray-600 mb-2">
          <strong>Afstand:</strong>{" "}
          {Math.round(dealership.sphericalDistanceInMeter / 1000)} km
        </p>
      ) : null}

      {dealership.travelTimeInMinutes &&
      dealership.travelTimeInMinutes !== undefined &&
      dealership.travelTimeInMinutes !== null &&
      dealership.travelTimeInMinutes > 0 ? (
        <p className="text-sm text-gray-600 mb-2">
          <strong>Reistijd:</strong> {dealership.travelTimeInMinutes} min
        </p>
      ) : null}

      <Button
        color={isSelected ? "green" : "primary"}
        className={`w-full mt-3${isSelected ? " bg-green-500 text-white border-green-500" : ""}`}
        onClick={() => onClick(dealership)}
      >
        {isSelected ? "Geselecteerd" : "Selecteer"}
      </Button>
    </Card>
  );
};
